import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Message } from 'primeng/components/common/api';
import { FormGroup, FormControl, Validators, FormBuilder, FormArray } from '@angular/forms';
import { Router } from '@angular/router';
import { RegistrationService } from '../../services/registration.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-payment-information',
  templateUrl: './payment-information.component.html',
  styleUrls: ['./payment-information.component.scss']
})
export class PaymentInformationComponent implements OnInit {

  msgs: Message[] = [];
  activeIndex = 4;
  paymentList: any = [];
  tableData: any = [];
  amount: any;
  amountPay: any;
  draftno: any;
  dataList: any = [];
  dataList1: any = [];
  display = false;
  admitsLink: any;
  processbar = false;
  showclose = false;
  forpayment: boolean = false;

  INDUSTRY_TYPE_ID: any;
  CHANNEL_ID: any;
  MID: any;
  CALLBACK_URL: any;
  WEBSITE: any;
  MERC_UNQ_REF: any;
  ORDER_ID: any;
  CUST_ID: any;
  MOBILE_NO: any;
  EMAIL: any;
  REQUEST_TYPE: any;
  TXN_AMOUNT: any;
  CHECKSUMHASH: any;
  VERIFIED_BY: any;
  @ViewChild('form') form: ElementRef;

  markedFst = false;
  markedScnd = false;
  buttonSubmit: boolean = true;
  hideDeclaration: boolean = false;

  //************ Below variable decleare for HDFC Payment *************
  fname: any;
  lname: any;
  phone: any;
  return_url: any;
  key: any;
  secure_hash: any;
  txnid: any;
  description: any;
  amount_txn_hdfc: any;
  email: any;
  udf1: any;
  udf2: any;
  udf3: any;
  udf4: any;
  udf5: any;
  @ViewChild('formhdfc') formhdfc: ElementRef;
  //End

  //************ Below variable decleare for Federal Online Payment *************

  merchantRequest: any;
  mid: any;
  checkout: any;
  federaludf1: any;
  federaludf2: any;
  federaludf3: any;
  federaludf4: any;
  federaludf5: any;
  @ViewChild('formfederal') formfederal: ElementRef;
  //End


  constructor(
    private registrationService: RegistrationService,
    private fb: FormBuilder,
    private router: Router,
    private spinner: NgxSpinnerService,
  ) { }

  ngOnInit() {
    this.msgs = [];
    if (localStorage.getItem('step') == '') {
      this.showclose = true;
    }
    this.msgs.push({ severity: 'info', summary: 'Please Note :' });
    this.msgs.push({ severity: 'info', summary: '1. In the payment type dropdown, choose either "PAYNIMO" or "PAYTM" Gateway for online payment.' });
    this.msgs.push({ severity: 'info', summary: '<strong><font color="red"> 2. "PAYNIMO" gateway has no additional banking charges. In "PAYTM" gateway, additional banking charges will be added with the fee amount. </font></strong>' });
    this.msgs.push({ severity: 'info', summary: '3.  Do not press F5, Refresh, Reload, Right-click, or Backspace during online payment.' });
    this.msgs.push({ severity: 'info', summary: '4. After successful payment, click "Print Application Fees Paid Challan" for receipt. In case of online payment, bank stamp is not required.' });
    this.msgs.push({ severity: 'info', summary: '5. If your challan lacks an E-paid stamp even after deduction of amount while making Online payment,<a href="https://docs.google.com/forms/d/e/1FAIpQLSekYGcZrRUQibOJW5Xz4kxB3PnicvZJ8vw6y6v3enAmWmhb7A/viewform?pli=1" target="_blank">  click here to notify us through Google form. </a>' });
    this.msgs.push({ severity: 'info', summary: '6. Cheque/D.D./RTGS/NEFT payments are not accepted and shall not be considered valid.' });
    this.msgs.push({ severity: 'info', summary: '7. For cash payments, select "Cash Payment at Federal Bank" to generate and download the payment challan. Visit any Federal Bank branch with the printout of the generated challan. <a href="https://thebges.edu.in/wp-content/uploads/2016/08/List-of-Federal-Bank-Branch.pdf" target="_blank"> View Kolkata branches here. </a>' });
    this.msgs.push({ severity: 'info', summary: '8. If your browser "popup" is blocked, you will see a red-coloured cross on the top right. Please click on it to enable the popup.' });

    this.getPaymentDetails();
    this.tableData = [];
  }

  ngAfterViewInit() {
    (document.querySelector('.layout-wrapper .layout-content .layout-content-container') as HTMLElement).style.marginTop = '40px';
  }
  ngOnDestroy() {
    (document.querySelector('.layout-wrapper .layout-content .layout-content-container') as HTMLElement).style.marginTop = '10px';
  }

  getPaymentDetails() {
    // call auto login and take user to the Academic Info
    //this.autoLogin();
    let challan = localStorage.getItem('challan');
    if (challan == null) {
      challan = '-';
    }

    this.registrationService.getPaymentDetails(localStorage.getItem('authToken'), challan).subscribe(
      data => {

        this.dataList = data;
        this.amount = this.dataList.amountPay;
        this.draftno = this.dataList.DraftNo;
        // console.log(this.draftno + "draft")
      }
      ,
      err => console.log(err),
      () => console.log('Request Completed')
    );
  }

  payment() {
    this.spinner.show();
    //alert((<HTMLInputElement>document.getElementById('pamentType')).value);
    var pType = (<HTMLInputElement>document.getElementById('pamentType')).value;

    if (pType == 'Paynimo') {
      this.registrationService.payPaynimo(this.draftno, localStorage.getItem('authToken'));
    }
    else {
      this.registrationService.submitPayement(pType, this.draftno, localStorage.getItem('authToken')).subscribe(
        data => {
          this.dataList1 = data;
          if (this.dataList1.status === 'success' && pType === 'Online PaymentP') {
            this.forpayment = true;

            this.INDUSTRY_TYPE_ID = this.dataList1.INDUSTRY_TYPE_ID;
            this.CHANNEL_ID = this.dataList1.CHANNEL_ID;
            this.MID = this.dataList1.MID;
            this.CALLBACK_URL = this.dataList1.CALLBACK_URL;
            this.WEBSITE = this.dataList1.WEBSITE;
            this.MERC_UNQ_REF = this.dataList1.MERC_UNQ_REF;
            this.ORDER_ID = this.dataList1.ORDER_ID;
            this.CUST_ID = this.dataList1.CUST_ID;
            this.MOBILE_NO = this.dataList1.MOBILE_NO;
            this.EMAIL = this.dataList1.EMAIL;
            this.REQUEST_TYPE = this.dataList1.REQUEST_TYPE;
            this.TXN_AMOUNT = this.dataList1.TXN_AMOUNT;
            this.CHECKSUMHASH = this.dataList1.CHECKSUMHASH;
            this.VERIFIED_BY = this.dataList1.VERIFIED_BY;

            setTimeout(() => {
              this.spinner.hide();
              this.pay('paytm')
            }, 2000);
            //window.open(this.dataList1.payurl,'mywin','left=20,top=20,width=500,height=500,toolbar=1,resizable=0');
            //window.open(this.dataList1.payurl,"_self");
          } else if (this.dataList1.status === 'success' && pType === 'Online PaymentH') {
            this.forpayment = true;

            this.fname = this.dataList1.fname;
            this.lname = this.dataList1.lname;
            this.phone = this.dataList1.phone;
            this.return_url = this.dataList1.return_url;
            this.key = this.dataList1.key;
            this.secure_hash = this.dataList1.secure_hash;
            this.txnid = this.dataList1.txnid;
            this.description = this.dataList1.description;
            this.amount_txn_hdfc = this.dataList1.amount;
            this.email = this.dataList1.email;
            this.udf1 = this.dataList1.udf1;
            this.udf2 = this.dataList1.udf2;
            this.udf3 = this.dataList1.udf3;
            this.udf4 = this.dataList1.udf4;
            this.udf5 = this.dataList1.udf5;

            setTimeout(() => {
              this.spinner.hide();
              this.pay('hdfc')
            }, 2000);
          }
          else if (this.dataList1.status === 'success' && pType === "Online PaymentF") {
            this.forpayment = true;

            this.merchantRequest = this.dataList1.merchantRequest;
            this.mid = this.dataList1.mid;
            // this.checkout = this.dataList1.checkout;
            this.federaludf1 = this.dataList1.udf1;
            this.federaludf2 = this.dataList1.udf2;
            this.federaludf3 = this.dataList1.udf3;
            this.federaludf4 = this.dataList1.udf4;
            this.federaludf5 = this.dataList1.udf5;

            setTimeout(() => {
              this.spinner.hide();
              this.pay('federal')
            }, 2000);
          } else {
            // console.log("cash")
            const name = this.dataList1.name;
            const emlbody = this.dataList1.emlbody;
            const emlpw = this.dataList1.emlpw;
            const emlsendto = this.dataList1.emlsendto;
            const emlsub = this.dataList1.emlsub;
            const emlun = this.dataList1.emlun
            this.registrationService.giveMsgForEmail(name, emlun, emlpw, emlsub, emlbody, emlsendto).then(response => {
              console.log('SMS sent successfully:', response);
            })
              .catch(error => {
                alert(error.message);
              });
            this.tableData = this.dataList1.challanLink;
            this.admitsLink = this.dataList1.admitsLink;
            if (this.admitsLink !== '') {
              this.spinner.hide();
              this.display = true;
            }
          }
        }
        , error => {
          alert('Something went wrong. Please try again')
          this.spinner.hide();
        }
      );
      //this.display = true;
    }
  }

  pay(v: any) {
    if (v === 'paytm') {
      this.form.nativeElement.submit();
    }
    // else {
    //   this.formhdfc.nativeElement.submit();
    // }
    else {
      this.formfederal.nativeElement.submit();
    }
  }
  openBranchList() {
    window.open('https://www.federalbank.co.in/web/guest/atm-branch-locator', "_blank");
  }
  goToDashboard() {
    this.router.navigate(['candidate/dashboard']);
  }

  toggleVisibility(val: boolean) {
    if (val) {
      this.markedFst = true;
      this.toggleVisibility3(this.markedFst, this.markedScnd);
    } else {
      this.markedFst = false;
      this.toggleVisibility3(this.markedFst, this.markedScnd);
    }
  }

  toggleVisibility1(val: boolean) {
    if (val) {
      this.markedScnd = true;
      this.toggleVisibility3(this.markedFst, this.markedScnd);
    } else {
      this.markedFst = false;
      this.toggleVisibility3(this.markedFst, this.markedScnd);
    }
  }

  toggleVisibility3(val1: boolean, val2: boolean) {
    if (val1 === val2)
      this.buttonSubmit = true;
    else
      this.buttonSubmit = false;
  }

  logOutFunction() {
    localStorage.clear();
    this.router.navigate(['']);
  }


}



// WEBPACK FOOTER //
// ./src/app/admission/payment-information/payment-information.component.ts